import {
  FETCH_BUSINESS_UNITS,
  FETCH_BUSINESS_UNITS_SUCCESS,
  FETCH_BUSINESS_UNITS_FAILURE,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE,
  SAVING_BUSINESS_UNIT,
  SAVING_BUSINESS_UNIT_SUCCESS,
  SAVING_BUSINESS_UNIT_FAILURE,
  SAVING_BUSINESS,
  SAVING_BUSINESS_SUCCESS,
  SAVING_BUSINESS_FAILURE,
} from './types';

const initialState = {
  businessUnits: [],
  businessUnitsLoading: false,
  enabledFlagValues: [],
  businessCodes: [],
  isSavingInProgress: false,
  isLoadingInitialDataForBusinessUnitModal: false,
  isSavingBusinessInProgress: false,
};

function businessUnitSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_BUSINESS_UNITS:
      return {
        ...state,
        businessUnitsLoading: true,
      };
    case FETCH_BUSINESS_UNITS_SUCCESS:
      return {
        ...state,
        businessUnits: action.businessUnits,
        businessUnitsLoading: false,
      };
    case FETCH_BUSINESS_UNITS_FAILURE:
      return {
        ...state,
        businessUnitsLoading: false,
      };
    case FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL:
      return {
        ...state,
        isLoadingInitialDataForBusinessUnitModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS:
      return {
        ...state,
        isLoadingInitialDataForBusinessUnitModal: false,
        enabledFlagValues: action.enabledFlagValues,
        businessCodes: action.businessCodes,
      };
    case FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE:
      return {
        ...state,
        isLoadingInitialDataForBusinessUnitModal: false,
      };
    case SAVING_BUSINESS_UNIT:
      return {
        ...state,
        isSavingInProgress: true,
      };
    case SAVING_BUSINESS_UNIT_SUCCESS:
    case SAVING_BUSINESS_UNIT_FAILURE:
      return {
        ...state,
        isSavingInProgress: false,
      };
    case SAVING_BUSINESS:
      return {
        ...state,
        isSavingBusinessInProgress: true,
      };
    case SAVING_BUSINESS_SUCCESS:
    case SAVING_BUSINESS_FAILURE:
      return {
        ...state,
        isSavingBusinessInProgress: false,
      };
    default:
      return state;
  }
}

export default businessUnitSettings;
